import ApiService from '@zola-helpers/client/dist/es/http/api';

export const publishWebsite = async (): Promise<void> =>
  ApiService.post<void>(`/web-api/v1/weddingAccount/publish`, { enable: true });
